import React, { useRef } from 'react'
import { FieldWrapper } from '@progress/kendo-react-form';
import { Error, Hint } from '@progress/kendo-react-labels';
import LabelPure from '../../../pures/label/label.pure';
import { TimePicker } from '@progress/kendo-react-dateinputs';

function TimepickerWrapper(fieldRenderProps) {
    const {
        touched,
        label,
        id,
        valid,
        hint,
        validationMessage,
        ...others
    } = fieldRenderProps;

    const editorRef = useRef(null);
    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : "";
    const errorId = showValidationMessage ? `${id}_error` : "";
    const labelId = label ? `${id}_label` : "";

    return (
        <FieldWrapper className={`timepickerWrapper ${showValidationMessage ? "timepickerWrapper-error" : ""}`}>
            <LabelPure
                id={labelId}
                editorId={id}
                className="k-form-label"
                title={label}
            />
            <div className={"k-form-field-wrap"}>
                <TimePicker
                    ariaLabelledBy={labelId}
                    ariaDescribedBy={`${hintId} ${errorId}`}
                    ref={editorRef}
                    id={id}
                    fillMode="flat"
                    rounded={false}
                    validationMessage={validationMessage}
                    {...others}
                    valid={!showValidationMessage}
                />
                {showHint && <Hint id={hintId}>{hint}</Hint>}
                {showValidationMessage && (
                    <Error id={errorId}>{validationMessage}</Error>
                )}
            </div>
        </FieldWrapper>
    )
};

export default TimepickerWrapper